import React from "react";
import "./Loader.css";
import BoyAnimation from "./BoyAnimation";
import TelegramText from "../Text/TelegramText";

const Loader = ({ title }) => {
  return (
    <div className="loading-popup">
      <div className="loading-popup-content">
        <div style={{ position: "relative", display: "inline-block" }}>
          <BoyAnimation size={60} speed={400} />
          {/* Fallback if animation fails */}
          <img 
            src="/boy_animation/stand1_0.png" 
            alt="Loading" 
            style={{ 
              width: "60px", 
              height: "60px",
              display: "none",
              imageRendering: "pixelated",
              position: "absolute",
              top: 0,
              left: 0
            }} 
            onError={(e) => { e.target.style.display = "block"; console.error("BoyAnimation fallback triggered"); }}
          />
        </div>
        <TelegramText className="telegramSubtitle">{title}</TelegramText>
      </div>
    </div>
  );
};

export default Loader;
